import React, { useState } from 'react';
import { RACEX_TOKEN_ADDRESS } from '../../../constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import './RaceXTokenAddress.css'

const RaceXTokenAddress = () =>{
  const [isCopied, setIsCopied] = useState(false);
  const onCopyText = () => {
    setIsCopied(true);
    navigator.clipboard.writeText(RACEX_TOKEN_ADDRESS)
    setTimeout(() => {
      setIsCopied(false);
    }, 2000);
  };

  return (
    <div className='raceXTokenAddr'>
      <label className='raceXTokenAddr__title'>RACEX TOKEN CONTRACT</label>
      <div className='raceXTokenAddr__box'>
        <label className='raceXTokenAddr__address'>{RACEX_TOKEN_ADDRESS}</label>
        {isCopied ?       
        <span>Copied!</span> :
        <FontAwesomeIcon icon={faCopy} className='raceXTokenAddr__icon' onClick={onCopyText} />
        }
      </div>
    </div>
  )
}

export default RaceXTokenAddress;